module.exports = __webpack_public_path__ + "img/Reproducir_sonido_Pequeño.555be9ec.svg";